import { useCallback } from 'react';
import { StanModal } from '@/components';
import { useStanRouter } from '@/hooks/useStanRouter';

export interface PublishSuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
    flowId: number;
    trigger: string;
    canAddAnotherEmail: boolean;
}

export const PublishSuccessModal = ({
    isOpen,
    onClose,
    flowId,
    trigger,
    canAddAnotherEmail,
}: PublishSuccessModalProps) => {
    const { push } = useStanRouter();

    const handleDone = useCallback(() => {
        onClose();
        push(`/flows?tab=flows&open=${flowId}`, { skipDirtyCheck: true });
    }, [flowId, push, onClose]);

    const handleAddAnother = useCallback(() => {
        onClose();
        push(`/flows/${flowId}/new?triggerType=${trigger}`, { skipDirtyCheck: true });
    }, [flowId, trigger, push, onClose]);

    return (
        <StanModal
            id='publish-success-modal'
            isOpen={isOpen}
            onClose={handleDone}
            title='Published! 🎉'
            size='sm'
            primaryActionLabel="I'm Done"
            secondaryActionLabel={canAddAnotherEmail ? 'Add Another Email' : undefined}
            onPrimaryAction={handleDone}
            onSecondaryAction={canAddAnotherEmail ? handleAddAnother : undefined}
            className='pt-4 pb-0!'
        >
            <p className='text-neutral-secondary -mt-2 text-center'>This email is now live in the flow.</p>
        </StanModal>
    );
};
